import { render, staticRenderFns } from "./TransferDetail.vue?vue&type=template&id=1615f79f&scoped=true"
import script from "./TransferDetail.vue?vue&type=script&lang=js"
export * from "./TransferDetail.vue?vue&type=script&lang=js"
import style0 from "./TransferDetail.vue?vue&type=style&index=0&id=1615f79f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1615f79f",
  null
  
)

export default component.exports